import * as routes from "./routes";

export default routes;
